import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { CustomToaster } from '../../BaseUI';
import EmailForm from './Form';

const queryClient = new QueryClient();

const Team = ({ companyName, currentUserEmail, guid }) => {
  return (
    <QueryClientProvider client={queryClient}>
      <CustomToaster />
      <EmailForm guid={guid} companyName={companyName} currentUserEmail={currentUserEmail} />
    </QueryClientProvider>
  );
};

export default Team;
